/**
 * Notifications Module Types
 */

/**
 * Приложение-адресат уведомления (DEV-1958). CRM читает только свои: до
 * разведения в этом колокольчике висели и задачи трекера, и уведомления
 * кабинета агента.
 */
export const NOTIFICATION_APP = 'crm'

/** Уведомление из API */
export interface Notification {
  id: string
  notificationType: string
  title: string
  body: string
  metadata: Record<string, unknown>
  channelsSent: string[]
  isRead: boolean
  createdAt: string
  readAt: string | null
  /** Приложение-адресат: для этой ленты всегда crm. */
  app: string
  /**
   * Готовая ссылка перехода от бэкенда. Раньше её не сохраняли, и переход
   * строился только из metadata.url — трекер его не кладёт, поэтому его
   * уведомления были некликабельны.
   */
  url: string
}

/** Настройка канала уведомлений */
export interface ChannelPreference {
  channel: string
  enabled: boolean
}

/** Настройка типа событий (DEV-701/DEV-767): отсутствие типа в ответе = включён. */
export interface TypePreference {
  notificationType: string
  enabled: boolean
}

/** Статус привязки Telegram Bot */
export interface TelegramBotStatus {
  linked: boolean
  telegramUsername: string
  verified: boolean
}

/** Код привязки Telegram Bot */
export interface TelegramBotLinkCode {
  linkCode: string
  botUsername: string
  deepLink: string
  expiresInSeconds: number
}

/** Web Push подписка */
export interface WebPushSubscriptionData {
  endpoint: string
  p256dhKey: string
  authKey: string
  userAgent: string
}

/** Пагинированный ответ списка уведомлений */
export interface NotificationsListResponse {
  notifications: Notification[]
  total: number
  page: number
  pageSize: number
}

/** Статус Web Push */
export type WebPushPermissionState = 'default' | 'granted' | 'denied'
